import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatSort
} from '@angular/material';
import { OrderService } from '../../../services/order/order.service';
import { AllorderdetailsComponent } from '../allorderdetails/allorderdetails.component';
import { DatePipe } from '@angular/common';
import { TokenStorage } from 'src/app/auth/token.storage';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-orderlistview',
  templateUrl: './orderlistview.component.html',
  styleUrls: ['./orderlistview.component.scss']
})
export class OrderlistviewComponent implements OnInit {

  columnsToDisplay = [
    'invoice',
    'zone',
    'deliveryEta',
    'origin',
    'receiver',
    'destination',
    'packageDetails',
    'numOfItems',
  ];

  orderDataArray = new MatTableDataSource();
  unplannedCount: number = 0;
  inPlanningCount: number = 0;
  scheduledCount: number = 0;
  intransitCount: number = 0;
  failedCount: number = 0;
  deliveredCount: number = 0;
  filter: string = 'date';
  ordersArray = [];
  selectedVal = '0';
  mapView: boolean = false;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  page: number = 0;
  totalRecords: number;
  typeOfOrder: string;
  fromDate: any;
  toDate: any;
  isLoading: boolean = false;
  isTenantDiag: boolean = false;
  subscription: Subscription
  oTypes: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input() data: string;
  constructor(public dialog: MatDialog,
    public orderService: OrderService,
    public datePipe: DatePipe,
    private token: TokenStorage
  ) {

    this.getNotification();
  }


  ngOnInit() {

    this.typeOfOrder = 'ORDER_STATE_UNPLANNED';
    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
      this.columnsToDisplay = [
        'invoice',
        'zone',
        'deliveryBoy',
        'department',
        'deliveryEta',
        'receiver',
        'origin',
        'destination',
        'packageDetails',
        'numOfItems',
      ];
      this.subscription = this.orderService.getOrderType().subscribe(type => {
        if(type == 'sample' || type == 'home') {
          this.oTypes = 'ORDER_TYPE_PICKUP';
        }else {
          this.oTypes = 'ORDER_TYPE_MARKETING_VISIT';
        }
        this.findOrders(this.selectedVal);
      });
    }else {
      this.oTypes = 'ORDER_TYPE_DELIVERY';
      this.isTenantDiag = false;
      this.findOrders(this.selectedVal);
    }  

    this.orderDataArray.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'receiver': return item.orderInfo.receiverName;
        case 'zone': return item.orderInfo.destinationAddress.zone || item.orderInfo.originAddress.zone;
        case 'deliveryEta': return item.orderInfo.deliveryETADateTime;
      }
    };
    this.orderDataArray.sort = this.sort;

  }
  onValChange() {
    this.notifyParent.emit('e');
  }

  getNotification() {
    //alert(evt);
  }

  searchArraryForCount(arr, value) {
    let count = 0;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].orderstatus === value) {
        count = count + arr[i].ordercount;
      }
    }
    return count;
  }

  filterList() {
    console.log(this.filter);
    if (this.filter === "week") {

    }
    console.log(this.ordersArray);
  }

  orderData(type) {
    //console.log(type);
    this.page = 0;
    this.paginator._pageIndex = 0;
    switch (type) {

      case "unplanned":
        this.orderDataArray.data = [];
        this.typeOfOrder = 'ORDER_STATE_UNPLANNED';
        this.getOrdersData();
        break;
      case "inplanning":
        this.typeOfOrder = 'ORDER_STATE_IN_PLANNING';
        this.getOrdersData();
        break;
      case "scheduled":
        this.typeOfOrder = 'ORDER_STATE_SCHEDULED';
        this.getOrdersData();
        break;
      case "intransit":
        this.typeOfOrder = 'ORDER_STATE_IN_TRANSIT';
        this.getOrdersData();
        break;
      case "failed":
        this.typeOfOrder = 'ORDER_STATE_FAILED';
        this.getOrdersData();
        break;
      case "delivered":
        this.typeOfOrder = 'ORDER_STATE_DELIVERED';
        this.getOrdersData();
        break;
      default:
        this.typeOfOrder = 'ORDER_STATE_UNPLANNED';
        this.getOrdersData();
    }
  }

  getOrdersData() {
    this.totalRecords = 0;
    this.isLoading = true;
    this.orderDataArray.data = [];
    this.getData(this.typeOfOrder, this.fromDate, this.toDate).subscribe(res => {
      this.isLoading = false;
      this.calculateNumOfItemsInOrder(res);
      this.orderDataArray.data = res.content;
      this.ordersArray = res.content;
      this.totalRecords = res.totalElements;
    });
  }

  getData(type, from, to) {

    if (type == 'ORDER_STATE_SCHEDULED')
      type = ['ORDER_STATE_SCHEDULED', 'ORDER_STATE_SCHEDULED_FOR_PICKUP']

    if (this.isTenantDiag) {
      return this.orderService.getAllOrdersByTypesAndOTypesDateRange(type, this.oTypes, this.page, from, to, 'nozone');
    }
    else {
      return this.orderService.getAllOrdersByTypesDateRange(type, this.page, from, to, 'nozone');
    }

  }

  ngOnDestroy() {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }

  pageChanged(event) {
    this.page = event.pageIndex;
    this.getOrdersData();
  }

  orderDetails(data) {
    let editDialog = this.dialog.open(AllorderdetailsComponent, {
      width: '800px',
      data: { data: data }
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
  }

  MapVIewSingle() {
    alert("mapiew");
  }

  findOrders(days) {
    this.isLoading = true;
    this.orderDataArray.data = [];
    let date, last, day, month, year;
    date = new Date();
    last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));
    day = last.getDate();
    month = last.getMonth();
    year = last.getFullYear();

    this.fromDate = this.datePipe.transform(new Date(year, month, day), 'yyyy-MM-dd');

    if (days == 1)
      this.toDate = this.datePipe.transform(new Date(year, month, day), 'yyyy-MM-dd');
    else
      this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.getOrderCountByStatus();
    this.getData(this.typeOfOrder, this.fromDate, this.toDate).subscribe(orders => {
      this.isLoading = false;
      this.calculateNumOfItemsInOrder(orders);
      this.orderDataArray.data = orders.content;
      this.totalRecords = orders.totalElements;
      if (this.orderDataArray.data.length === 0) {
        this.totalRecords = 0;
        this.page = 0;
        this.paginator._pageIndex = 0;
      }
      console.log("Orders", orders);
    });
  }

  getOrderCountByStatus() {
    this.unplannedCount = 0;
    this.inPlanningCount = 0;
    this.scheduledCount = 0;
    this.intransitCount = 0;
    this.failedCount = 0;
    this.deliveredCount = 0;
    this.orderService.getOrderCountByStatus(this.fromDate, this.toDate, [this.oTypes]).subscribe(res => {
      console.log("order count by status", res);
      if (res.length != 0) {
          this.unplannedCount = this.searchArraryForCount(res, 'ORDER_STATE_UNPLANNED');
          this.inPlanningCount = this.searchArraryForCount(res, 'ORDER_STATE_IN_PLANNING');
          this.scheduledCount = this.searchArraryForCount(res, 'ORDER_STATE_SCHEDULED') + this.searchArraryForCount(res, 'ORDER_STATE_SCHEDULED_FOR_PICKUP');
          this.intransitCount = this.searchArraryForCount(res, 'ORDER_STATE_IN_TRANSIT');
          this.failedCount = this.searchArraryForCount(res, 'ORDER_STATE_FAILED');
          this.deliveredCount = this.searchArraryForCount(res, 'ORDER_STATE_DELIVERED');
      }
    });
  }

  calculateNumOfItemsInOrder(orderArray) {
    console.log(orderArray)
    orderArray.content.forEach(function (order) {
      let numOfItemsInOrder = 0;
      order.prodQList.forEach(function (prod) {
        numOfItemsInOrder = numOfItemsInOrder + prod.productQuantity;
      });
      order.numOfItemsInOrder = numOfItemsInOrder
    });
  }


}

export interface OrderListElement {
  zone: string,
  receiver: string,
  orderInvoiceNumber: string,
  deliveryETADate: string,
  packageDetails: string,
  originAddress: string,
  destinationAddress: string,
  numOfItems: string,
  action: string
}